import { render, staticRenderFns } from "./vault-sidebar.vue?vue&type=template&id=14cab04b&scoped=true"
import script from "./vault-sidebar.vue?vue&type=script&lang=js"
export * from "./vault-sidebar.vue?vue&type=script&lang=js"
import style0 from "./vault-sidebar.vue?vue&type=style&index=0&id=14cab04b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14cab04b",
  null
  
)

export default component.exports